import { render, staticRenderFns } from "./TablesFooter.vue?vue&type=template&id=70436f8c&scoped=true&"
import script from "./TablesFooter.vue?vue&type=script&lang=js&"
export * from "./TablesFooter.vue?vue&type=script&lang=js&"
import style0 from "./TablesFooter.vue?vue&type=style&index=0&id=70436f8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70436f8c",
  null
  
)

export default component.exports